var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-3.542 93.702 646.959 262",
    width: 646.959,
    height: 262,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1, 0, 0, 1, -4.583101, 91.742279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.007899,38.7650154 C126.007899,34.7383476 129.263975,31.4816286 133.298472,31.4816286 L386.871877,31.4816286 C390.898902,31.4816286 394.162451,34.7405 394.162451,38.7650154 L394.162451,212.307477 C394.162451,216.334145 390.906375,219.590864 386.871877,219.590864 L133.298472,219.590864 C129.271447,219.590864 126.007899,216.331993 126.007899,212.307477 L126.007899,38.7650154 Z",
    id: "Case",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.409667,50.7365341 C142.409667,49.0123794 143.813338,47.612711 145.535934,47.612711 L374.37407,47.612711 C376.102828,47.612711 377.500337,49.004393 377.500337,50.7365341 L377.500337,180.042016 C377.500337,181.766171 376.096666,183.165839 374.37407,183.165839 L145.535934,183.165839 C143.807176,183.165839 142.409667,181.774157 142.409667,180.042016 L142.409667,50.7365341 Z",
    id: "Case",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.989547,219.590864 L279.441148,219.590864 L282.037136,253.153923 L238.39356,253.153923 L240.989547,219.590864 Z",
    id: "Case",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.334407,253.411496 L222.334407,256.926514 C222.334407,259.006825 224.024461,260.699106 226.104395,260.699106 L294.3263,260.699106 C296.402444,260.699106 298.096288,259.006629 298.096288,256.926514 L298.096288,253.411496 C298.096288,253.265769 297.983625,253.153923 297.834738,253.153923 L222.595957,253.153923 C222.450148,253.153923 222.334407,253.269384 222.334407,253.411496 Z",
    id: "Keyboard",
    strokeWidth: 2.08142999,
    transform: "translate(260.215348, 256.926514) scale(1, -1) translate(-260.215348, -256.926514) ",
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    strokeWidth: 2.08142999,
    cx: 260.215348,
    cy: 202.809335,
    rx: 4.81639213,
    ry: 4.81330685,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Case",
    strokeWidth: 2.08142999,
    x: 101.275074,
    y: 159.749752,
    width: 51.5470788,
    height: 100.949355,
    rx: 6.24428997,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.275074,170.937438 L152.822153,170.937438 L152.822153,245.686792 L101.275074,245.686792 L101.275074,170.937438 Z",
    id: "Case",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 114.812374,
    y: 164.17279,
    width: 24.7328244,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 124.184813,
    y: 250.031778,
    width: 5.93587786,
    height: 5.93207547,
    rx: 2.96603774,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    strokeWidth: 2.08142999,
    cx: 115.853757,
    cy: 208.142999,
    rx: 3.9051828,
    ry: 3.90268123,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 124.96585,
    y: 201.378352,
    width: 18.2241864,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 124.96585,
    y: 207.102284,
    width: 13.017276,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 124.96585,
    y: 212.826216,
    width: 7.81036561,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-7",
    strokeWidth: 2.08142999,
    cx: 74.8493371,
    cy: 168.725919,
    rx: 39.9637045,
    ry: 39.9374379,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Case",
    strokeWidth: 2.08142999,
    x: 319.704966,
    y: 120.462761,
    width: 192.654351,
    height: 129.308838,
    rx: 6.24428997,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.42601,250.02579 L306.42601,255.235353 C306.42601,258.248347 308.874337,260.699106 311.88835,260.699106 L520.175933,260.699106 C523.187441,260.699106 525.638273,258.249893 525.638273,255.235353 L525.638273,250.02579 C525.638273,249.884133 525.525092,249.771599 525.379413,249.771599 L306.68487,249.771599 C306.538643,249.771599 306.42601,249.8841 306.42601,250.02579 Z",
    id: "Keyboard",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.428848,249.888735 L401.270407,249.88823 C402.433781,252.961493 405.402425,255.091813 408.808279,255.091813 L422.891133,255.091813 C426.2974,255.091813 429.265465,252.961765 430.428848,249.888735 Z",
    id: "Notch",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Screen",
    strokeWidth: 2.08142999,
    x: 328.295034,
    y: 132.691162,
    width: 175.319716,
    height: 105.073079,
    rx: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3",
    cx: 254.357573,
    cy: 49.9543198,
    rx: 1.3017276,
    ry: 1.30089374,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.899422,11.9682224 L300.177718,11.9682224 L300.177718,127.227794 C300.177718,131.24909 296.908511,134.512413 292.886465,134.512413 L187.190674,134.512413 C183.165634,134.512413 179.899422,131.247907 179.899422,127.227794 L179.899422,11.9682224 Z",
    id: "Case",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.899422,6.23775036 C179.899422,2.21962044 183.168858,-1.040715 187.190674,-1.040715 L292.886465,-1.040715 C296.913475,-1.040715 300.177718,2.21613142 300.177718,6.23775036 L300.177718,14.0496524 L179.899422,14.0496524 L179.899422,6.23775036 Z",
    id: "Case",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    cx: 191.093612,
    cy: 6.50446872,
    rx: 2.34310968,
    ry: 2.34160874,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    cx: 198.903978,
    cy: 6.50446872,
    rx: 2.34310968,
    ry: 2.34160874,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    cx: 206.714343,
    cy: 6.50446872,
    rx: 2.34310968,
    ry: 2.34160874,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 194.478104,
    y: 87.9404171,
    width: 4.68621937,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 194.478104,
    y: 35.9046673,
    width: 4.68621937,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.329184,35.9046673 L210.359847,35.9046673 C210.934619,35.9046673 211.400562,36.3706113 211.400562,36.9453823 C211.400562,37.5201533 210.934619,37.9860973 210.359847,37.9860973 L203.329184,37.9860973 C202.754413,37.9860973 202.288469,37.5201533 202.288469,36.9453823 C202.288469,36.3706113 202.754413,35.9046673 203.329184,35.9046673 Z",
    id: "Rectangle-11",
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.044733,35.9046673 L222.075396,35.9046673 C222.650167,35.9046673 223.116111,36.3706113 223.116111,36.9453823 C223.116111,37.5201533 222.650167,37.9860973 222.075396,37.9860973 L215.044733,37.9860973 C214.469962,37.9860973 214.004018,37.5201533 214.004018,36.9453823 C214.004018,36.3706113 214.469962,35.9046673 215.044733,35.9046673 Z",
    id: "Rectangle-11",
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.760281,35.9046673 L239.778891,35.9046673 C240.353662,35.9046673 240.819606,36.3706113 240.819606,36.9453823 C240.819606,37.5201533 240.353662,37.9860973 239.778891,37.9860973 L226.760281,37.9860973 C226.18551,37.9860973 225.719566,37.5201533 225.719566,36.9453823 C225.719566,36.3706113 226.18551,35.9046673 226.760281,35.9046673 Z",
    id: "Rectangle-11",
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.463776,35.9046673 L263.730679,35.9046673 C264.30545,35.9046673 264.771394,36.3706113 264.771394,36.9453823 C264.771394,37.5201533 264.30545,37.9860973 263.730679,37.9860973 L244.463776,37.9860973 C243.889005,37.9860973 243.423061,37.5201533 243.423061,36.9453823 C243.423061,36.3706113 243.889005,35.9046673 244.463776,35.9046673 Z",
    id: "Rectangle-11",
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 194.478104,
    y: 46.3118173,
    width: 4.68621937,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 194.478104,
    y: 56.7189672,
    width: 4.68621937,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 194.478104,
    y: 67.1261172,
    width: 4.68621937,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 194.478104,
    y: 77.5332671,
    width: 4.68621937,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 194.478104,
    y: 98.347567,
    width: 4.68621937,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 194.478104,
    y: 108.754717,
    width: 4.68621937,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 202.288469,
    y: 46.3118173,
    width: 18.2241864,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 223.116111,
    y: 46.3118173,
    width: 31.2414624,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 256.961029,
    y: 46.3118173,
    width: 13.017276,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 202.288469,
    y: 56.7189672,
    width: 13.017276,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 217.9092,
    y: 56.7189672,
    width: 13.017276,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 233.529932,
    y: 56.7189672,
    width: 7.81036561,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 202.288469,
    y: 67.1261172,
    width: 26.034552,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 230.926476,
    y: 67.1261172,
    width: 18.2241864,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 202.288469,
    y: 77.5332671,
    width: 26.034552,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 230.926476,
    y: 77.5332671,
    width: 33.8449176,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 202.288469,
    y: 87.9404171,
    width: 18.2241864,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 223.116111,
    y: 87.9404171,
    width: 18.2241864,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 243.943753,
    y: 87.9404171,
    width: 10.4138208,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 202.288469,
    y: 98.347567,
    width: 33.8449176,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 202.288469,
    y: 108.754717,
    width: 15.6207312,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.991426,93.6643496 L557.659437,93.6643496 L557.659437,195.142937 C557.659437,199.162932 554.399545,202.419067 550.373649,202.419067 L422.277215,202.419067 C418.255898,202.419067 414.991426,199.157214 414.991426,195.142937 L414.991426,93.6643496 Z",
    id: "Case",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.991426,87.9338775 C414.991426,83.9126798 418.251232,80.6554121 422.277215,80.6554121 L550.373649,80.6554121 C554.397843,80.6554121 557.659437,83.9124627 557.659437,87.9338775 L557.659437,95.7457795 L414.991426,95.7457795 L414.991426,87.9338775 Z",
    id: "Case",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    cx: 426.185617,
    cy: 88.2005958,
    rx: 2.34310968,
    ry: 2.34160874,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    cx: 433.995982,
    cy: 88.2005958,
    rx: 2.34310968,
    ry: 2.34160874,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    cx: 441.806348,
    cy: 88.2005958,
    rx: 2.34310968,
    ry: 2.34160874,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    strokeWidth: 2.34160874,
    cx: 503.247891,
    cy: 148.041708,
    rx: 26.034552,
    ry: 26.0178749,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.383423,118.901688 L500.383423,125.145978 L506.63305,125.145978 L506.63305,118.901688 L500.383423,118.901688 Z",
    id: "Rectangle-12",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.123077,170.937438 L500.123077,177.181728 L506.372704,177.181728 L506.372704,170.937438 L500.123077,170.937438 Z",
    id: "Rectangle-12",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.088525,145.179742 L474.088525,151.424032 L480.338152,151.424032 L480.338152,145.179742 L474.088525,145.179742 Z",
    id: "Rectangle-12",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.897284,145.179742 L525.897284,151.424032 L532.146911,151.424032 L532.146911,145.179742 L525.897284,145.179742 Z",
    id: "Rectangle-12",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 529.282443,
    y1: 124.625621,
    x2: 529.282443,
    y2: 144.139027,
    id: "Line",
    strokeWidth: 2.08142999,
    strokeLinecap: "square",
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 529.282443,
    y1: 151.944389,
    x2: 529.282443,
    y2: 171.457795,
    id: "Line",
    strokeWidth: 2.08142999,
    strokeLinecap: "square",
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    cx: 529.282443,
    cy: 123.845084,
    rx: 3.12414624,
    ry: 3.12214499,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    cx: 529.282443,
    cy: 173.279047,
    rx: 3.12414624,
    ry: 3.12214499,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(439.463238, 115.519364)",
    fill: "#FFFFFF",
    stroke: "#7510F7",
    strokeWidth: 2.08142999
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    x: 1.040715,
    y: 1.040715,
    width: 16.1427564,
    height: 16.1310824,
    rx: 3.12214499,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    x: 1.040715,
    y: 24.4568024,
    width: 16.1427564,
    height: 16.1310824,
    rx: 3.12214499,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    x: 1.040715,
    y: 47.8728898,
    width: 16.1427564,
    height: 16.1310824,
    rx: 3.12214499,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-8",
    strokeWidth: 2.08142999,
    cx: 632.379269,
    cy: 235.982125,
    rx: 15.6207312,
    ry: 15.6107249,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-8",
    strokeWidth: 2.08142999,
    cx: 632.379269,
    cy: 235.982125,
    rx: 9.11209321,
    ry: 9.10625621,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-8",
    strokeWidth: 2.08142999,
    cx: 611.551627,
    cy: 212.305859,
    rx: 5.20691041,
    ry: 5.20357498,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.639887,211.004965 C588.065116,211.004965 587.599172,211.470909 587.599172,212.04568 L587.599172,255.75571 C587.599172,258.629565 589.928892,260.959285 592.802747,260.959285 L628.720118,260.959285 C631.593973,260.959285 633.923693,258.629565 633.923693,255.75571 L633.923693,212.04568 C633.923693,211.470909 633.457749,211.004965 632.882978,211.004965 L588.639887,211.004965 Z",
    id: "Rectangle-16",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    strokeWidth: 2.08142999,
    x: 609.728541,
    y: 225.054618,
    width: 13.5393012,
    height: 16.6514399,
    rx: 3.12214499,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 616.368019,
    y1: 211.395233,
    x2: 616.368019,
    y2: 223.233366,
    id: "Line-2",
    strokeWidth: 2.08142999,
    strokeLinecap: "square",
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.92045,260.699106 C566.547542,260.699106 573.541181,260.699106 573.541181,260.699106 C573.541181,252.077541 566.547542,245.088381 557.92045,245.088381 C549.293358,245.088381 542.299719,252.077541 542.299719,260.699106 C542.299719,260.699106 549.293358,260.699106 557.92045,260.699106 Z",
    id: "Oval-8",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 556.879068,
    y: 244.568024,
    width: 2.08276416,
    height: 3.38232373,
    rx: 1.04138208,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.391389,229.997886 C7.91344584,229.997886 1.040715,236.870617 1.040715,245.34856 C1.040715,253.826503 7.91344584,260.699234 16.391389,260.699234 L79.4070531,260.699234 C80.2692097,260.699234 80.9681256,260.000318 80.9681256,259.138161 L80.9681256,256.722169 C80.9681256,255.629844 80.123732,254.723351 79.0341503,254.645969 C71.8803755,254.137863 68.0805122,250.995245 68.0805122,245.34856 C68.0805122,239.701873 71.8803788,236.559254 79.0341596,236.05115 C80.1237345,235.973762 80.9681256,235.06727 80.9681256,233.974951 L80.9681256,231.558958 C80.9681256,230.696802 80.2692097,229.997886 79.4070531,229.997886 L16.391389,229.997886 Z",
    id: "Rectangle-17",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1864202,255.299762 C80.1864202,255.551575 79.9821545,255.75571 79.73018,255.75571 L79.73018,255.75571 L72.353427,255.75571 L16.1414223,255.75571 C10.3900278,255.75571 5.72760145,251.09627 5.72760145,245.34856 C5.72760145,239.60085 10.3900278,234.94141 16.1414223,234.94141 L72.353427,234.94141 L79.73018,234.94141 L79.73018,234.94141 C79.9821545,234.94141 80.1864202,235.145545 80.1864202,235.397358",
    id: "Rectangle-19",
    strokeWidth: 2.08142999,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-18",
    x: 14.0586581,
    y: 240.925521,
    width: 54.6725593,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-18",
    x: 14.0586581,
    y: 247.42999,
    width: 54.6725593,
    height: 2.08142999,
    rx: 1.040715,
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1265421,178.055093 C63.848875,176.91993 62.5712079,175.784766 61.2935408,174.649603 C59.2574411,172.842608 57.2271756,171.029822 55.1910759,169.222827 C54.7243482,168.81162 54.2576205,168.394621 53.7967269,167.983414 C53.7967269,168.527829 53.7967269,169.078035 53.7967269,169.622451 C55.074394,168.487287 56.3520611,167.352124 57.6297282,166.21696 C59.6658279,164.409965 61.6960934,162.597179 63.7321931,160.790184 C64.1989208,160.378977 64.6656485,159.961978 65.1265421,159.550771 C65.5816017,159.145355 65.5757676,158.317149 65.1265421,157.911734 C64.6423121,157.465777 63.965557,157.47736 63.4754929,157.911734 C62.1978257,159.046897 60.9201586,160.182061 59.6424915,161.317224 C57.6063919,163.124219 55.5761263,164.937006 53.5400267,166.744 C53.0732989,167.155208 52.6065712,167.572206 52.1456776,167.983414 C51.6964522,168.383037 51.6964522,169.222827 52.1456776,169.622451 C53.4233447,170.757614 54.7010118,171.892778 55.978679,173.027941 C58.0147786,174.834936 60.0450442,176.647722 62.0811438,178.454717 C62.5478715,178.865924 63.0145992,179.282923 63.4754929,179.69413 C63.9305524,180.099546 64.6831508,180.174837 65.1265421,179.69413 C65.5349289,179.253965 65.6107721,178.489467 65.1265421,178.055093 L65.1265421,178.055093 Z",
    id: "Shape",
    fillRule: "nonzero",
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5825817,159.553526 C85.8602488,160.688689 87.1379159,161.823853 88.415583,162.959016 C90.4516827,164.766011 92.4819482,166.578798 94.5180479,168.385793 C94.9847756,168.797 95.4515033,169.213999 95.9123969,169.625206 C95.9123969,169.080791 95.9123969,168.530584 95.9123969,167.986169 C94.6347298,169.121332 93.3570627,170.256496 92.0793956,171.391659 C90.0432959,173.198654 88.0130304,175.011441 85.9769307,176.818435 C85.510203,177.229643 85.0434753,177.646641 84.5825817,178.057849 C84.1275221,178.463264 84.1333562,179.29147 84.5825817,179.696886 C85.0668117,180.142843 85.7435668,180.131259 86.2336309,179.696886 C87.5112981,178.561722 88.7889652,177.426559 90.0666323,176.291395 C92.1027319,174.4844 94.1329975,172.671614 96.1690971,170.864619 C96.6358249,170.453412 97.1025526,170.036413 97.5634462,169.625206 C98.0126716,169.225582 98.0126716,168.385793 97.5634462,167.986169 C96.2857791,166.851005 95.008112,165.715842 93.7304448,164.580678 C91.6943452,162.773684 89.6640796,160.960897 87.62798,159.153902 C87.1612523,158.742695 86.6945246,158.325696 86.2336309,157.914489 C85.7785714,157.509074 85.025973,157.433782 84.5825817,157.914489 C84.1741949,158.354654 84.0983517,159.119152 84.5825817,159.553526 L84.5825817,159.553526 Z",
    id: "Shape",
    fillRule: "nonzero",
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6937286,184.875712 C71.0437744,183.833215 71.3879861,182.790718 71.7380319,181.74243 C72.5723077,179.234645 73.4065835,176.732652 74.2408593,174.224868 C75.2443239,171.201626 76.2477884,168.184177 77.2570871,165.160935 C78.1263675,162.548901 78.9956479,159.936867 79.8649282,157.324832 C80.2791491,156.056461 80.7458768,154.793881 81.1309271,153.508135 C81.1367612,153.49076 81.1425953,153.473385 81.1484294,153.45601 C81.3409546,152.882637 80.9267338,152.164472 80.3316559,152.031264 C79.6899053,151.886473 79.1006616,152.222388 78.8964682,152.842095 C78.5464224,153.884592 78.2022107,154.927089 77.852165,155.975378 C77.0178892,158.483162 76.1836134,160.985155 75.3493376,163.49294 C74.345873,166.516181 73.3424084,169.533631 72.3331097,172.556872 C71.4638294,175.168907 70.594549,177.780941 69.7252686,180.392975 C69.3110478,181.655555 68.8443201,182.918135 68.4592697,184.203881 C68.4534356,184.221256 68.4476015,184.238631 68.4417674,184.256006 C68.2492422,184.829379 68.6634631,185.547544 69.2585409,185.680752 C69.9002915,185.825543 70.4895353,185.489627 70.6937286,184.875712 L70.6937286,184.875712 Z",
    id: "Shape",
    fillRule: "nonzero",
    style: {
      stroke: "rgb(102, 252, 241)",
      fill: "rgb(9, 9, 9)",
      paintOrder: "fill",
      fillRule: "evenodd"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/Computer.08d52db8.svg";
export { ForwardRef as ReactComponent };